import { DatePicker } from 'material-ui-pickers';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import lightBlue from '@material-ui/core/colors/blueGrey';
import MomentUtils from 'material-ui-pickers/utils/moment-utils';
import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider';
import React, { PureComponent } from 'react';

const materialTheme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#37474f',
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: lightBlue.A200,
        // color: 'white',
      },
    },
    MuiButtonBase: {
      focusVisible: false,
    },
    MuiPickersDay: {
      day: {
        color: lightBlue.A700,
      },
      selected: {
        backgroundColor: '#37474f',
      },
      current: {
        color: lightBlue['900'],
      },
    },
    MuiPickersModal: {
      dialogAction: {
        color: '#37474f',
      },
    },
  },
});

export default class Picker extends PureComponent {
  handleDateChange = date => {
    this.props.handleDateChange(date);
  };

  render() {
    const { selectedDate } = this.props;

    return (
      <MuiThemeProvider theme={materialTheme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <div className="pickers">
            <DatePicker
              autoOk
              leftArrowIcon={<KeyboardArrowLeft />}
              rightArrowIcon={<KeyboardArrowRight />}
              minDate={new Date()}
              value={selectedDate}
              label={this.props.label ? this.props.label : ''}
              clearable
              onChange={this.handleDateChange}
              format="YYYY MM DD"
            />
          </div>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    );
  }
}
